<template>
  <div class="modal_dim on"><!--'on 추가'-->
    <div class="modal_wrap">
      <div class="modal_inner center w1200">
        <div class="modal_con" style="padding: 60px; background-color: #F8F8F8;">
          <!--'로그인, 아이디찾기, 비밀번호찾기: grey'-->
          <!-- 휴면해제하기 (서남아이에스 임현아, 2024-07-10) -->
          <div class="inner">
            <div class="page_ttl">
              <h1 class="h1">
                <span>휴면해제하기</span>
              </h1>
            </div>
            <div class="page_con">
              <div class="find_id w420">
                <div class="form">
                  <ul class="form_ul">
                    <li class="form_li">
                      <div class="form_ttl">
                        <p>이름</p>
                      </div>
                      <div class="form_in">
                        <div class="input">
                          <input type="text" placeholder="이름을 입력해 주세요" v-model="name">
                          <p class="valid" :class="{ on: $v.name.$error }">이름을 입력해주세요.</p>
                          <!--'on 추가'-->
                        </div>
                      </div>
                    </li>
                    <li class="form_li">
                      <div class="form_ttl">
                        <p>휴대폰 번호</p>
                      </div>
                      <div class="form_in">
                        <div class="input">
                          <input type="text" placeholder="-를 제외하고  입력해 주세요" v-model="userPhone" id="userPhone"
                            oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '');">
                        </div>
                        <p class="valid" :class="{ on: $v.userPhone.$error }">{{ msg.userPhone }}</p><!--'on 추가'-->
                        <button class="btn bo" @click="fnAuth">{{ msg.send }}</button>
                        <div class="inline time_count">
                          <div class="input">
                            <input type="number" v-model="authNumber" id="authNumber">
                            <span class="time" id="time" style="color: red;" v-show="isRunning">{{ count }}</span>
                          </div>
                          <button class="btn bo grey" disabled v-on:click="fnConfirmAuth" id="block2">인증하기</button>
                        </div>
                        <p class="valid">인증번호를 입력해주세요.</p><!--'on 추가'-->
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="page_btn">
                  <button class="btn bo grey" v-on:click="$router.go(-1)">이전으로</button>
                  <button class="btn" v-on:click="fnInactiveChange">휴면해제하기</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'modal-change-user-status-inactive',
  description: '회원 상태값 변경 모달',
  props: {
    data: {
      type: [Array, Object],
      default: () => { }
    },
    callBack: {
      type: [Function]
    }
  },
  data() {
    return {
      userNo: -1,
      name: '',
      userPhone: '',
      authNumber: '', // 인증번호
      authConfirmNumber: '', // 발송된 인증번호,
      isAuth: false,  // 인증번호 인증여부
      isRunning: false, // 타이머 작동 여부
      msg: {
        send: '인증번호 발송',
        userPhone: ''
      },
      count: '03:00',
      timeCounter: 180 // 3분
    }
  },
  destroyed() {
    this.fnStop()
  },
  methods: {
    fnInactiveChange: function () {
      if (!this.$Util.isValid(this.$v, this.$el)) return false
      const params = {}
      params.status = Number(1)
      params.userPhone = this.userPhone
      if (this.isAuth === false) {
        alert('휴대폰인증을 해주세요')
        return false
      }
      //휴면해제하기 API
      this.$SignSvc.userModifyStatus(params).then(res => {
        if (res.code === 1) {
          alert('정상적으로 휴면해제 처리 되었습니다.\n로그인을 진행해주세요.')
          this.$router.push({ path: '/main' })
        } else {
          alert('아이디가 존재하지 않습니다.')
        }
      })
    },
    fnAuth: function () {
      if (!this.$Util.isValid(this.$v, this.$el)) return false

      const params = {}
      params.name = this.name
      params.userPhone = this.userPhone

      this.$AuthSvc.send(params).then(res => {
        if (res.code === 1) {
          this.authConfirmNumber = res.entity // 발송된 인증번호 넣어주기
          // 발송후 핸드폰 번호칸은  readonly
          this.msg.send = '재전송'
          document.getElementById("userPhone").readOnly = true
          document.getElementById("block2").disabled = false
          // 인증번호 타이머 시작 (세팅시간 3분)
          this.fnTimer()
          this.isRunning = true
      
        } else {
          alert('입력하신 휴대폰 번호로 연결된 계정이 없습니다.')
        }
      })
    },
    fnConfirmAuth: function () {
      // 인증번호 칸이 빈 값일 경우 리턴 false
      if (this.$Util.isEmpty(this.authNumber)) return false
      if (this.authNumber !== this.authConfirmNumber) {
        alert('인증번호가 일치하지 않습니다.')
        return false
      } else {
        alert('인증되었습니다.')
        this.fnStop()
        document.getElementById("block2").disabled = true
        this.isRunning = false // 타이머 숨기기
        this.isAuth = true
      }
    },
    fnTimer: function () {
      this.fnStop()
      this.timer = setInterval(() => {
        this.timeCounter--
        if (this.timeCounter <= 0) {
          this.fnStop()
          alert('인증시간이 초과되었습니다.')
          document.getElementById("block2").disabled = true
        }
        let time = this.timeCounter / 60
        let min = parseInt(time)
        let sec = Math.round((time - min) * 60)
        this.count = this.pad(min, 2) + ':' + this.pad(sec, 2)
      }, 1000)
    },
    pad: function (n, width) {
      n = n + ''
      return n.length >= width ? n : new Array(width - n.length + 1).join('0') + n
    },
    fnStop: function () {
      clearInterval(this.timer)
      this.timeCounter = 180
      this.count = "03:00"
    }
  },
  validations: {
    name: {
      required
    },
    userPhone: {
      test: function (val) {
        if (this.$Util.isEmpty(val)) {
          this.msg.userPhone = '휴대폰 번호를 입력해주세요.'
          return false
        }
        return true
      }
    }
  }
}
</script>

<style scoped></style>
